import { oz } from '@weft/utils';

export const EnvironmentApiParametersSchema = oz.object({
  accountsForSqlDb: oz.string().array(),
  allowedOrigins: oz.string().array(),
  apiUrl: oz.string(),
  hubspotSecretsId: oz.string(),
  netSuiteSecretsId: oz.string(),
  slackSecretsId: oz.string(),
  clientUrl: oz.string(),
});

export type EnvironmentApiParameters = oz.infer<typeof EnvironmentApiParametersSchema>;